import { AxiosInstance } from 'axios';
import * as qs from 'querystring';
import _createAPI from './_createAPI';
import { pro } from './mode'
let host = 'https://duet.mangoebike.com';

if (!pro || process.env.NODE_ENV !== 'production') {
  // host = 'http://hi.mangoebike.cc:4004';
  host = 'http://localhost:4004';
  if (window.location.search.length > 0) {
    const query = qs.parse(window.location.search.slice(1));
    if (query.mango2Host) {
      host = query.mango2Host as string;
    }
  }
}

if (process.env.REACT_APP_ENV === 'staging') {
  host = 'https://duet.staging.mangoebike.cc';
}

export default _createAPI(host, 'admin', 'v3') as AxiosInstance;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/v3.ts